/* eslint arrow-body-style: 0 */
import { frontendURL } from '../../../helper/URLHelper';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';
import KanbanView from './KanbanView.vue';

const KANBAN_PERMISSIONS = [...ROLES, ...CONVERSATION_PERMISSIONS];

export const routes = [
  {
    path: frontendURL('accounts/:accountId/kanban'),
    name: 'kanban_conversations',
    meta: {
      permissions: KANBAN_PERMISSIONS,
    },
    component: KanbanView,
  },
  {
    path: frontendURL('accounts/:accountId/kanban/:viewKey'),
    name: 'kanban_view_conversations',
    meta: {
      permissions: KANBAN_PERMISSIONS,
    },
    component: KanbanView,
  },
];
